import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

const LINKS = [
  ["nav.about", "/about"], ["nav.services", "/services"],
  ["nav.education", "/education-academics"], ["nav.industries", "/industries"],
  ["nav.insights", "/insights"], ["nav.store", "/store"], ["nav.contact", "/contact"],
];

const LocalClock = ({ tz, testId }) => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const update = () =>
      setTime(new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz }).format(new Date()));
    update();
    const id = setInterval(update, 10000);
    return () => clearInterval(id);
  }, [tz]);
  return (
    <span data-testid={testId} className="font-mono text-xs text-silver tracking-wider">
      {time} local
    </span>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-navy text-cream-surface border-t border-navy-border">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex flex-col leading-tight mb-5">
              <span className="font-serif text-2xl">Ruten Borealis</span>
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-silver mt-1">
                架け橋 Kakehashi · Japan–Canada
              </span>
            </div>
            <p className="text-sm leading-relaxed text-[#B7C6E2] max-w-sm">
              {t("footer.tagline")}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] font-mono text-coral-light mb-5">{t("footer.navigate")}</p>
            <ul className="space-y-2.5">
              {LINKS.map(([key, to]) => (
                <li key={key}>
                  <Link to={to} data-testid={`footer-${key.split(".")[1]}`} className="text-sm text-cream-surface/80 hover:text-coral transition-colors duration-300">
                    {t(key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] font-mono text-coral-light mb-5">{t("footer.offices")}</p>
            <div className="space-y-5 text-sm">
              <div>
                <p className="font-medium mb-1">Tokyo</p>
                <p className="text-cream-surface/70 leading-relaxed">Shibuya City, Tokyo 150-0002, Japan<br />+81 3-6822-4170</p>
                <p className="mt-2"><LocalClock tz="Asia/Tokyo" testId="clock-tokyo" /></p>
              </div>
              <div>
                <p className="font-medium mb-1">Toronto</p>
                <p className="text-cream-surface/70 leading-relaxed">1 Yonge Street, Suite 1801<br />Toronto, ON M5E 1E5, Canada<br />+1 (416) 555-0184</p>
                <p className="mt-2"><LocalClock tz="America/Toronto" testId="clock-toronto" /></p>
              </div>
              <p className="text-cream-surface/70">hello@rutenborealis.com</p>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-7 border-t border-navy-border flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-silver">© 2026 Ruten Borealis Inc. {t("footer.rights")}</p>
          <div className="flex items-center gap-5">
            <span data-testid="footer-privacy-link" className="text-xs text-silver hover:text-cream-surface transition-colors duration-300 cursor-pointer">Privacy Policy</span>
            <span data-testid="footer-terms-link" className="text-xs text-silver hover:text-cream-surface transition-colors duration-300 cursor-pointer">Terms of Service</span>
            <p className="text-xs text-silver font-mono tracking-wider hidden md:inline">35.6762° N, 139.6503° E ⇄ 43.6532° N, 79.3832° W</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
